import React, { Component } from 'react';
import Axios from 'axios';
import Cards from './Cards';

class CovidData extends Component{
    constructor(props){
        super(props);
        this.state={
            confirmed:0,
            active: 0,
            recovered: 0,
            deceased: 0,
            daily_confirmed:0,
            daily_recovered: 0,
            daily_deceased: 0,
            place: "Etawah"
        }
        this.fetchData = this.fetchData.bind(this);
    }
    componentDidMount(){
        this.fetchData();
    }
    async fetchData(){
        await Axios.get(`https://api.covid19india.org/state_district_wise.json`)
        .then(resp => {
            var place1 = this.state.place;
            this.setState({
                confirmed: resp.data["Uttar Pradesh"].districtData[place1].confirmed,
                recovered: resp.data["Uttar Pradesh"].districtData[place1].recovered,
                active: resp.data["Uttar Pradesh"].districtData[place1].active,
                deceased: resp.data["Uttar Pradesh"].districtData[place1].deceased,
            })
        })
        .catch(
            err => console.log(err));
    }
    render(){
        return(
            <div>
                <Cards {...this.state}/>
                <br />
            </div>
        )
    }
}
export default CovidData;